<div
  *ngIf="!fromTraining"
  style="height: 100vh; width: 100%"
  class="d-flex flex-column align-items-center justify-content-between"
>
  <app-admin-header
    style="width: 100%"
    [header]="header"
    [links]="links"
    [breadcrumbs]="breadcrumbs"
    [stats]="stats"
    [queryParams]="queryParams"
  ></app-admin-header>

  <!-- new ui section  -->

  <div class="w-100">
    <!-- skelition   -->
    <app-skelitions
      [hidden]="!skelition"
      [value]="2"
      class="mb-2"
    ></app-skelitions>
  </div>
  <p-toast></p-toast>
  <div class="container-fluid my-5 mob-px-5 777" *ngIf="!skelition">
    <div class="row">
      <div class="col-lg-2 col-md-2 col-sm-12 col-12 m-0">
        <div class="option-box">
          <h4 class="heading textt-900 mx-2 mt-2 active-panel">
            {{ "Question Bank Heading" | translator }}
          </h4>
          <div class="v4-scroll">
            <app-question-bank
              [tags]="allTags"
              [currentQBank]="currentQBank"
              [questionBanks]="questionBanks"
              (assessment)="changeCurrentQBank($event)"
              (updateDataEvent)="ngOnInit()"
            ></app-question-bank>
          </div>
        </div>
        <div *ngIf="!skelition" class="w-100 mt-2">
          <p-paginator
            [hidden]="totalDocuments <= 0"
            (onPageChange)="onPageChange($event)"
            [first]="first"
            [rows]="rows"
            [totalRecords]="totalDocuments"
            [rowsPerPageOptions]="[10, 20, 30]"
          ></p-paginator>
        </div>
      </div>
      <div class="col-lg-10 col-md-10 col-sm-12 col-12">
        <div class="option-box-2 mob-top-2">
          <p-tabView
            class="v4-dsbrd-btns ui-tabview"
            [activeIndex]="activeTabIndex"
            (onChange)="onTabChange($event)"
          >
            <p-tabPanel
              class="ui-tabview"
              header="{{ 'Assessments' | translator }}"
              *ngIf="standardQBID != currentQBankId"
            >
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div
                    *ngIf="!!currentQBank"
                    class="d-flex align-items-center gap-2"
                  >
                    <button (click)="createModal()" class="mb-3 v4-btn-every">
                      <i class="pi pi-plus-circle mx-2"></i
                      >{{ "New Assessment" | translator }}
                    </button>
                    <!-- <button
                      *ngIf="hasPermission('SURVEY_TAGS', 'c') || hasPermission('SURVEY_TAGS', 'u') || hasPermission('SURVEY_TAGS', 'd')"
                      routerLink="/assessment/tags-management" class="mb-3 v4-btn-border">
                      <i class="pi pi-plus-circle mx-2"></i>{{ "Tags Management" | translator }}
                    </button> -->
                  </div>
                  <div *ngIf="originalAssessments.length > 0" class="search-container mb-3">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="{{ 'search' | translator }}"
                      [(ngModel)]="searchQuery"
                      (keyup)="filterAssessments()"
                    />
                  </div>
                  <div *ngIf="assessments.length === 0" class="mt-2">
                    <app-no-data></app-no-data>
                  </div>
                  <div class="outer-wrapper">
                    <div class="table-wrapper">
                      <table *ngIf="assessments.length > 0" class="mt-2">
                        <thead style="height: 60px">
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                [(ngModel)]="checkboxValue"
                                (ngModelChange)="markAll()"
                              />
                            </th>
                            <th
                              class="clickable"
                              (click)="sortAssessments('name')"
                              class="table-row-mob-width clickable"
                            >
                              <span>{{ "Assessment name" | translator }}</span>
                              <i
                                class="pi"
                                [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'name' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'name' &&
                                    sortDirection === 'desc'
                                }"
                              ></i>
                            </th>
                            <th
                              *ngIf="!currentQBank"
                              class="table-row-mob-width-type clickable"
                              (click)="sortAssessments('type')"
                            >
                              <span>{{ "Type" | translator }}</span>
                              <i
                                class="pi"
                                [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'type' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'type' &&
                                    sortDirection === 'desc'
                                }"
                              ></i>
                            </th>
                            <th class="table-row-mob-width-name">
                              {{ "Created By" | translator }}
                            </th>
                            <th
                              class="clickable"
                              (click)="sortAssessments('createdAt')"
                            >
                              <span>{{ "Created" | translator }}</span>
                              <i
                                class="pi"
                                [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'createdAt' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'createdAt' &&
                                    sortDirection === 'desc'
                                }"
                              ></i>
                            </th>
                            <th
                              class="clickable"
                              (click)="sortAssessments('updatedAt')"
                            >
                              <span>{{ "Modified" | translator }}</span>
                              <i
                                class="pi"
                                [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'updatedAt' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'updatedAt' &&
                                    sortDirection === 'desc'
                                }"
                              ></i>
                            </th>
                            <th
                              class="clickable"
                              (click)="sortAssessments('startDate')"
                            >
                              <span>{{ "Start Date" | translator }}</span>
                              <i
                                class="pi"
                                [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'startDate' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'startDate' &&
                                    sortDirection === 'desc'
                                }"
                              ></i>
                            </th>
                            <th
                              class="clickable"
                              (click)="sortAssessments('endDate')"
                            >
                              <span>{{ "End Date" | translator }}</span>
                              <i
                                class="pi"
                                [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'endDate' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'endDate' &&
                                    sortDirection === 'desc'
                                }"
                              ></i>
                            </th>
                            <th
                              class="clickable"
                              (click)="sortAssessments('status')"
                            >
                              <span>{{ "the condition" | translator }}</span>
                              <i
                                class="pi"
                                [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'status' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'status' &&
                                    sortDirection === 'desc'
                                }"
                              ></i>
                            </th>
                            <th
                              class="clickable"
                              (click)="sortAssessments('attempts')"
                            >
                              <span>{{ "Responses" | translator }}</span>
                              <i
                                class="pi"
                                [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'attempts' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'attempts' &&
                                    sortDirection === 'desc'
                                }"
                              ></i>
                            </th>
                            <th>{{ "Actions" | translator }}</th>
                          </tr>
                          <br />
                        </thead>
                        <tbody>
                          <tr
                          *ngFor="let assessment of assessments; let i = index"
                          >
                            <td>
                              <input
                                type="checkbox"
                                [(ngModel)]="assessment.selected"
                                (ngModelChange)="
                                  selectAssessment(assessment, $event)
                                "
                              />
                            </td>
                            <td
                              class="table-row-mob-width show-count d-flex flex-row gap-2 align-items-center"
                              style="color: rgb(172 172 223)"
                            >
                              <p-button
                                class="v4-ui"
                                (onClick)="setCloneQestions(assessment,assessment.questionBank._id)"
                                styleClass="p-button-rounded p-button-text"
                                icon="pi pi-copy"
                              ></p-button>
                              <p-button
                                class="v4-ui"
                                (onClick)="openResultsPage(assessment)"
                                styleClass="p-button-rounded p-button-text"
                                icon="pi pi-chart-bar"
                              ></p-button>
                              <span
                                (click)="openAddQuestionsPage(assessment)"
                                class="align-self-center"
                                style="font-size: 14px"
                                role="button"
                              >
                                {{ assessment.name }}</span
                              >
                              <span
                                class="question-count"
                                style="color: dodgerblue"
                              >
                                Questions{{ assessment.questions.length }}</span
                              >
                            </td>
                            <td *ngIf="!currentQBank">
                              {{ assessment.questionBank?.name }}
                            </td>
                            <td>{{ getName(assessment?.createdBy?.name) }}</td>
                            <td>{{ assessment.createdAt | date }}</td>
                            <td>{{ assessment.updatedAt | date }}</td>
                            <td>
                              {{ getTransformedDate(assessment.startDate) }}
                            </td>
                            <td>
                              {{ getTransformedDate(assessment.endDate) }}
                            </td>
                            <td>
                              <select
                                name="{{ assessment.status }}"
                                id="{{ assessment.status }}"
                                [(ngModel)]="assessment.status"
                                (ngModelChange)="
                                  updateAssessmentData(assessment)
                                "
                              >
                                <option
                                  *ngFor="let option of statusOptions"
                                  [value]="option"
                                >
                                  {{ getStatusArabic(option) }}
                                </option>
                              </select>
                            </td>
                            <td [style]="{ 'text-align': 'center' }">{{ assessment.attempts }}</td>
                            <td>
                              <p-menu
                                #menu
                                [model]="menuItems"
                                [popup]="true"
                                appendTo="body"
                              ></p-menu>
                              <p-button
                                class="v4-ui"
                                (onClick)="
                                  openAssessmentMenu(menu, $event, assessment)
                                "
                                styleClass="p-button-rounded p-button-text"
                                icon="pi pi-ellipsis-v"
                              ></p-button>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr
                            *ngIf="
                              selectedAssessments.length == 0;
                              else editHeader
                            "
                          >
                            <td colspan="9" class="text-center">
                              {{ "Select Items to view options" | translator }}
                            </td>
                          </tr>

                          <ng-template #editHeader>
                            <tr>
                              <td colspan="1">
                                <span
                                  >{{ "selected" | translator }}
                                  {{ selectedAssessments.length }}</span
                                >
                              </td>
                              <td colspan="7">

                                <p-button
                                  *ngIf="false"
                                  (onClick)="
                                    assessmentActionCall({
                                      action: 'Group',
                                      bulk: true
                                    })
                                  "
                                  styleClass="v4-btn-every mx-2"
                                  icon="pi pi-folder"
                                  label="{{ 'Create Group' | translator }}"
                                ></p-button>

                                <p-button
                                  (onClick)="
                                    assessmentActionCall({
                                      action: 'Results',
                                      bulk: true
                                    })
                                  "
                                  styleClass="v4-btn-every mx-2"
                                  icon="pi pi-chart-bar"
                                  label="{{ 'Results' | translator }}"
                                ></p-button>

                                <p-button
                                  (onClick)="
                                    assessmentActionCall({
                                      action: 'Delete',
                                      bulk: true
                                    })
                                  "
                                  styleClass="v4-btn-every"
                                  icon="pi pi-trash"
                                  label="{{ 'Delete' | translator }}"
                                ></p-button>
                              </td>
                            </tr>
                          </ng-template>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel
              header="{{ 'Topics' | translator }}"
              *ngIf="!!currentQBank"
            >
              <app-question-bank-list
                [currentQBank]="currentQBank"
                [currentQBankId]="currentQBankId"
                [activeTabIndex]="activeTabIndex"
                [questionBankService]="questionBankService"
                [questionBankTopics]="questionBankTopics"
                [ministries]="ministries"
                [topics]="topics"
                (updateDataEvent)="ngOnInit()"
              ></app-question-bank-list>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
  </div>
  <!-- end -->

  <!-- Confirm Modal -->
  <p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

  <!-- Update Data Modal -->
  <p-dialog
    [blockScroll]="true"
    [draggable]="false"
    header="Header"
    [(visible)]="updateModal"
    (onHide)="onDialogClose()"
    [style]="{ margin: '0rem 1rem' }"
  >
    <ng-template pTemplate="header">
      <span class="text-xl font-bold">{{ "Update" | translator }}</span>
    </ng-template>
    <app-dynamic-form
      *ngIf="updateModal"
      [questions]="updateQuestions"
      (sendData)="updateAssessmentData($event)"
    ></app-dynamic-form>
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  </p-dialog>

  <!-- Create new Modal -->
  <p-dialog
    [blockScroll]="true"
    [draggable]="false"
    header="Header"
    [(visible)]="openCreateModal"
    (onHide)="onDialogClose()"
    [style]="{ margin: '0rem 1rem', width: '60%' }"
  >
    <ng-template pTemplate="header">
      <span class="text-xl font-bold">{{
        "Create a new assessment" | translator
      }}</span>
    </ng-template>
    <app-dynamic-form
      [questions]="questions"
      (sendData)="receiveAssessmentData($event)"
    ></app-dynamic-form>
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  </p-dialog>

  <app-footer style="width: 100%"></app-footer>
</div>

<section *ngIf="fromTraining">
  <app-dynamic-form
    [questions]="
      updateModal && updateAssesData?._id ? updateQuestions : questions
    "
    (sendData)="
      updateModal && updateAssesData?._id
        ? updateAssessmentData($event)
        : receiveAssessmentData($event)
    "
  ></app-dynamic-form>

  <p-messages [(value)]="messages" [enableService]="false"></p-messages>
</section>
